var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useContext, useEffect, useRef, useState, } from "react";
import { getCandleStickTechnicalAnalysis } from "../../../apis/dashboard";
import { Tabs } from "../../../components/tabs/tabs";
import { getEnvironmentVariableOrEmpty } from "../../../utils/methods";
import styles from "./indicator-widget.module.scss";
import { ThemeContext } from "src/contexts/theme-context";
import { captureCleverTabAnalytics } from "src/utils/analytics";
const { REACT_APP_URL_ASSET_BASE_PATH } = process.env;
const tabs = [
    { label: "5 minutes", id: "5" },
    { label: "15 minutes", id: "15" },
    { label: "Daily", id: "daily" },
];
const IndicatorWidget = ({ id, symbol, }) => {
    const intervalRef = useRef(undefined);
    const theme = useContext(ThemeContext);
    const [selectedTab, setSelectedTab] = useState("5");
    const [indicatorData, setIndicatorData] = useState({
        bearish: 0,
        bullish: 0,
        neutral: 0,
        overall: "bullish",
        imagePath: getEnvironmentVariableOrEmpty(REACT_APP_URL_ASSET_BASE_PATH) +
            `/fno/assets/svgs/indication_buy${theme.theme == "dark" ? "-dark" : ""}.svg`,
    });
    useEffect(() => {
        if (intervalRef.current) {
            clearTimeout(intervalRef.current);
            intervalRef.current = undefined;
        }
        //getData(selectedTab);
        return () => {
            if (intervalRef.current) {
                clearTimeout(intervalRef.current);
                intervalRef.current = undefined;
            }
        };
    }, [selectedTab, theme.theme]);
    const onTabChange = useCallback((tabId) => {
        setSelectedTab(tabId);
        captureCleverTabAnalytics("Overview_click", {
            Action: "Signals",
            Screen_Name: id,
            Time: tabId == "daily" ? tabId : tabId + "Min",
        });
    }, [selectedTab]);
    const getData = useCallback((tabId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield getCandleStickTechnicalAnalysis(tabId, symbol);
            if (response.status == 200) {
                setIndicatorDataCallback(response.data.data[0].netStrength);
            }
        }
        catch (err) {
            console.error("error !!!!!!! ", err);
        }
        finally {
            intervalRef.current = setTimeout(() => {
                getData(tabId);
            }, 300000);
        }
    }), [selectedTab, indicatorData, theme.theme]);
    const setIndicatorDataCallback = useCallback((data) => {
        if (data.overall == "bullish") {
            if (data.bullish >= 7) {
                data.imagePath =
                    getEnvironmentVariableOrEmpty(REACT_APP_URL_ASSET_BASE_PATH) +
                        `/fno/assets/svgs/indication_${theme.theme == "dark" ? "strong-buy-dark" : "strong_buy"}.svg`;
            }
            else {
                data.imagePath =
                    getEnvironmentVariableOrEmpty(REACT_APP_URL_ASSET_BASE_PATH) +
                        `/fno/assets/svgs/indication_buy${theme.theme == "dark" ? "-dark" : ""}.svg`;
            }
        }
        else if (data.overall == "bearish") {
            if (data.bearish >= 7) {
                data.imagePath =
                    getEnvironmentVariableOrEmpty(REACT_APP_URL_ASSET_BASE_PATH) +
                        `/fno/assets/svgs/indication_${theme.theme == "dark" ? "strong-sell-dark" : "strong_sell"}.svg`;
            }
            else {
                data.imagePath =
                    getEnvironmentVariableOrEmpty(REACT_APP_URL_ASSET_BASE_PATH) +
                        `/fno/assets/svgs/indication_sell${theme.theme == "dark" ? "-dark" : ""}.svg`;
            }
        }
        else {
            data.imagePath =
                getEnvironmentVariableOrEmpty(REACT_APP_URL_ASSET_BASE_PATH) +
                    `/fno/assets/svgs/indication_neutral${theme.theme == "dark" ? "-dark" : ""}.svg`;
        }
        setIndicatorData(data);
    }, [indicatorData, theme.theme]);
    const getTabData = useCallback((tabId) => {
        return (_jsxs("div", Object.assign({ className: `${styles.imgBoxWrapper}` }, { children: [_jsx("div", Object.assign({ className: `${styles.imgBox1}` }, { children: _jsx("img", { src: indicatorData.imagePath, alt: "Indicator-image" }) })), _jsxs("ul", Object.assign({ className: `${styles.indicatonList}` }, { children: [_jsxs("li", { children: [_jsx("span", Object.assign({ className: `${styles.redText}` }, { children: "1" })), " ", "Sell"] }), _jsxs("li", { children: [_jsx("span", Object.assign({ className: `${styles.greenText}` }, { children: "7" })), " ", "Buy"] }), _jsxs("li", { children: [_jsx("span", Object.assign({ className: `${styles.greyText}` }, { children: indicatorData.neutral })), " ", "Neutral"] })] })), _jsxs("span", Object.assign({ className: `${styles.poweredByNote}` }, { children: ["Powered by ", _jsx("strong", Object.assign({ className: "mediumWeight" }, { children: " Investobull" }))] }))] })));
    }, [indicatorData]);
    return (_jsx(React.Fragment, { children: _jsxs("div", Object.assign({ className: `${styles.indicationTabWrapper} meterTabStyle` }, { children: [_jsx(Tabs, { tabs: tabs, selectedTab: selectedTab, onTabChange: onTabChange }), _jsx("div", Object.assign({ className: `${styles.tabBody} w-100` }, { children: getTabData(selectedTab) }))] })) }));
};
export default IndicatorWidget;
